
import MegaMenu from "./components/lang-selector";
import LangSelector from "./components/megamenu";
import SiteHeader from "./components/site-header";
import SearchToggler from "./components/search-toggler";
import HomeSlider from "./components/home-slider";
import NewsSlider from "./components/news-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import BackToTop from "./components/back-to-top";
import Accordion from "./components/accordion";
import Gallery from "./components/gallery";
import ResidentsSlider from "./components/residents-slider";
import NewsletterForm from "./components/newsletter-form";
import ScrollInView from "./components/scroll-in-view";
import CasaWatermark from "./components/casa-watermark";
import CartSummary from "./components/cart-summary";
import ResidentFilters from "./components/resident-filters";
import Solr from "./components/solr";
import btnScrollDown from "./components/btn-scroll-down";
import scrollToAnchor from "./components/scroll-to-anchor";

import DeviceManager from "./utils/device-manager";


(function($) {
    $(function () {
        const bootstrapApp = () => {
            const $html = $("html");

            // Touch device detection
            if (DeviceManager.isHandheld()) {
                $html.addClass("touch");

                if (DeviceManager.isIos()) {
                    $html.addClass("ios");
                }
            } else {
                $html.addClass("no-touch");
            }

            // IE detection
            if (DeviceManager.isIe11()) {
                $html.addClass("ie11");
            } else if (DeviceManager.isEdge()) {
                $html.addClass("edge");
            }
        };

        const instanciateComponents = () => {
            // General components
            const siteHeader = new SiteHeader($(".site-header"), 20);
            const $residentFilters = $(".resident-filters");
            if ($residentFilters.length) {
                new ResidentFilters($residentFilters);
            }

            // Home slider component
            const $homesSliders = $(".homepage-slider");
            if ($homesSliders.length) {
                $homesSliders.each(function (index, el) {
                    const homeSlider = new HomeSlider($(el));
                });
            }

            // News slider component
            const $newsSliders = $(".frame-type-news_newsliststicky.frame-layout-carousel .news-list-view");
            if ($newsSliders.length) {
                $newsSliders.each(function (index, el) {
                    const newsSlider = new NewsSlider($(el));
                });
            }

            // Partners slider component
            const $partnersSliders = $(".partners-slider");
            if ($partnersSliders.length) {
                $partnersSliders.each(function (index, el) {
                    const partnerSlider = new PartnersSlider($(el));
                });
            }

            // Reviews slider component
            const $reviewsSlider = $(".reviews-slider");
            if ($reviewsSlider.length) {
                $reviewsSlider.each(function (index, el) {
                    const reviewsSlider = new ReviewsSlider($(el));
                });
            }

            // Portal page slider component
            const $portalPageSliders = $(".portal-page__header-slider");
            if ($portalPageSliders.length) {
                $portalPageSliders.each(function (index, el) {
                    const portalPageSlider = new PortalPageSlider($(el));
                });
            }

            // Newsletter form component
            const $newsletterFormElements = $(
                ".footer-block.footer-block--newsletter-style"
            );
            if ($newsletterFormElements.length) {
                $newsletterFormElements.each(function (index, el) {
                    const newsletterForm = new NewsletterForm(el);
                });
            }

            // Cookie consent
            if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
                // Tarteaucitron cookie settings
                let tarteaucitronLang = "fr";

                const cookiesConsent = new CookiesConsent(tarteaucitronLang);
            }

            // Scroll in view component
            const $scrollInViewElements = $(".scroll-in-view");
            if ($scrollInViewElements.length) {
                $scrollInViewElements.imagesLoaded(function () {
                    const scrollInView = new ScrollInView($scrollInViewElements);
                });
            }
        };

        bootstrapApp();
        instanciateComponents();
    });
})(jQuery);



